import type { GiftHistoryRequest } from './requests';

const getGiftHistoryParams = (data: GiftHistoryRequest) => {
    const params = new URLSearchParams();
    if (data.year) {
        params.set('year', data.year.toString());
    }
    if (data.page) {
        params.set('page', data.page.toString());
    }
    if (data.perPage) {
        params.set('per_page', data.perPage.toString());
    }
    return params.toString();
};

export const DonorEndpoints = {
    getProfile: () => '/donor/profile?expand=wallets',
    updateProfile: () => '/donor/profile',
    getGiftByUUID: (giftUUID: string) =>
        `/donor/profile/gift-by-uuid/${giftUUID}`,
    getReceipt: (receiptId: number | string) =>
        `/donor/profile/gifts/${receiptId}`,
    getGiftHistory: (data: GiftHistoryRequest) => {
        const params = getGiftHistoryParams(data);
        return `/donor/profile/gifts-history${params ? `?${params}` : ''}`;
    },
    getGiftSummary: () => '/donor/profile/gifts-summary',
    setPreferredWallet: (walletId: number) =>
        `/donor/profile/wallets/${walletId}/setAsPreferred`,
    deleteWallet: (walletId: number) => `/donor/profile/wallets/${walletId}`,
    getAllRecurringDonations: () => '/donor/profile/recurring-gifts',
    cancelRecurringDonation: (recurringId: number) =>
        `/donor/profile/recurring-gifts/${recurringId}`,
};
